import React from 'react';
import FlipCard from './FlipCard';
import './Education.css';

const Education = () => {
  const educationData = [
    {
      title: "University of Michigan, Ann Arbor",
      subtitle: "Bachelor of Arts in Political Science",
      date: "August 2020 – May 2024",
      location: "Ann Arbor, MI",
      front: "Graduated with a Bachelor of Arts in Political Science, with international study experience in Stockholm and active involvement in Greek Life.",
      back: [
        "Bachelor of Arts in Political Science",
        "Participant, DIS Stockholm Semester Summer 2023 - International study abroad program",
        "Member, Delta Phi Epsilon Sorority - Active involvement in Greek Life community",
        "Strong foundation in political theory, public policy, and legal studies",
        "Experience in research, critical analysis, and written communication"
      ]
    }
  ];

  return (
    <section id="education" className="section education">
      <h2 className="section-title">Education</h2>
      <div className="cards-container">
        {educationData.map((education, index) => (
          <FlipCard
            key={index}
            title={education.title}
            subtitle={education.subtitle}
            date={education.date}
            location={education.location}
            front={education.front}
            back={education.back}
            animationDelay={index * 100} // Staggered delay: 0ms, 100ms, etc.
          />
        ))}
      </div>
    </section>
  );
};

export default Education;
